module.exports = __webpack_public_path__ + "static/media/arrow-rightup.d8e591ce.svg";